import React  from 'react';
import TrainerBasicInfoComponent from './trainer-basic-info.component';
import TrainerAccountInfoComponent from './trainer-account-info.component';
import TrainerUserProfileInfoComponent from './trainer-user-profile-info.component';
import TrainerAddressComponent from './trainer-address.component';
import TrainerInfoComponent from './trainer-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';



export const TrainerComponent = ({handleBasicFormChange, selectedAddress,handleInnerFormChange,id,tagNames,selectedTrainers,back,accounts,handleFormSubmit,gstType,gstRegistrationType}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Ventures Details',
        component:<TrainerBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedTrainers={selectedTrainers}
        id={id}
        tagNames={tagNames}
       />,
    isVisible:true,
    },
    {
      id:2,
      title:'Account Info',
      component:<TrainerAccountInfoComponent 
      handleInnerFormChange={handleInnerFormChange}
      selectedTrainers={selectedTrainers}
      accounts={accounts}
      handleBasicFormChange={handleBasicFormChange}
     />,
  isVisible:true,
  },
    {
        id:3,
        title:'User Profile',
        component:<TrainerUserProfileInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedTrainers={selectedTrainers}
       />,
    isVisible:true,
    },
    {
      id: 4,
      title: 'Address',
      component: <TrainerAddressComponent
        onInnerFormChange={handleInnerFormChange}
        selectedAddress={selectedAddress}
      />,
      isVisible: true,
    },

    //  {
    //     id:5,
    //     title:'Tax Info',
    //     component:<TrainerTaxDetailsComponent 
    //     handleInnerFormChange={handleInnerFormChange}
    //     selectedTrainers={selectedTrainers}
    //     gstType={gstType}
    //     gstRegistrationType={gstRegistrationType}
    //    />,
    // isVisible:true,
    // },

     {
        id:6,
        title:'Trainer Info',
        component:<TrainerInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedTrainers={selectedTrainers}
        tagNames={tagNames}
       />,
    isVisible:true,
    },
   

  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default TrainerComponent;
